<template>
  <div id="app" :class="className">
    <AppBar v-show="!loading"></AppBar>
    <main v-show="!loading">
      <router-view></router-view>
      <img :src="logo" class="logo-login" />

      <Popups v-show="!loading"></Popups>
    </main>
  </div>
</template>
<script>
import AppBar from "../components/AppBar.vue";

export default {
  components: {
    AppBar,
    Popups: () => import("../components/Popup.vue"),
  },
  computed: {
    empresa() {
      return this.$store.state.empresa;
    },
    logo() {
      return this.empresa.imgs.logo_login;
    },
    className() {
      return this.empresa.className;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
};
</script>
<style lang="less" scoped>
@import "/css/buttons.less";
#app {
  height: 100vh;
  width: 100vw;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 106px 1fr;
  padding-bottom: 0;
}
main {
  overflow-y: auto;

  //background-image: linear-gradient(to bottom, #cdd6df, white);
  background-color: var(--primary);
  display: flex;
  flex-direction: column;
  /*justify-content: space-between;*/
}
.logo-login {
  display: block;
  margin: auto;
  margin-top: 1em;
  margin-bottom: 2em;
  max-width: 60vw;
  max-height: 15vh;
}
</style>
